<template>
  <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
  <button class="returnBtn" @click="back">返回</button>
   <div class="container bg-white mt-2" v-if="!isLoading">
   <p v-for="(error,index) in errors" :key="index">{{ error }}</p>   

    <div >
        <div class="mt-1 d-flex flex-column bg-white m-1 p-1 pt-3">
        

          <div class="row d-flex justify-content-center" v-if="note_type=='img'">
              <div v-for="(img,index) in imgs" :key="index" class="col m-1" style="width:25%">
                  <div>

                      <img :src="img" class="img mr-1" @click="view(img)">
                      <div class="d-flex justify-content-between" style="width:3.5rem;">
                        <div class="backBtn ml-1" @click="deleteItem(index)">删除</div>

                          <div class="backBtn ml-1" @click="selectFile(index)">替换</div>
                      </div>
                      
                     
                  </div>
              </div>                              
          </div>
          <div v-else>
            {{ video_url }}
          </div>
          <div class="d-flex justify-content">

            <input type="file" ref="fileInput" style="display: none" @change="uploadFolder(0,false)"  accept="image/*">

            <input type="file" ref="filesInput" multiple style="display: none" @change="uploadFolder(1,false)"  accept="image/*">
            <div @click="selectFiles" class="ml-2 btnAdd" style="width: max-content" v-if="folderUploadProgress==0 || folderUploadProgress==101">上传图片</div>


             <input type="file" ref="videoInput" style="display: none" @change="uploadFolder(2,true)"  accept="video/*">
            <div @click="selectVideo" class="ml-2 btnAdd" style="width: max-content" v-if="folderUploadProgress==0 || folderUploadProgress==101">上传视频</div>

            <div v-if="folderUploadProgress>0&&folderUploadProgress<101">
                    正在上传文件：{{folderUploadProgress}}%
                    <progress :value="folderUploadProgress" max="100"></progress>

       
    </div>
          </div>
         

          <div class="d-flex justify-content mt-2">
           <div>标题：</div>
           <div class="flex-fill"> <input type="text mt-1" v-model="title" style="width: 100%;"></div>
          </div>
         

          <div class="mt-1 d-flex justify-content">
            文案： <div class="flex-fill"><textarea v-model="content" rows="20" style="width: 100%;"></textarea></div>
          </div>

         

          <div class="d-flex justify-content mt-1">
           <div>标签：</div>
           <div class="flex-fill"> <input type="text mt-1" v-model="tags" style="width: 100%;"></div>
          </div>
          <div class="d-flex justify-content mt-1">
           <div>计划发送日期：</div>
           <input id="datePicker" type="date" v-model="currentDate">
           <input id="timePicker" type="time" v-model="currentTime">
          </div>
          <div>

          </div>
            
        </div>

      </div>
      

   
       <div class="d-flex justify-content-center p-1">
       

        <button class="btn normalBtn" @click="new_note()" >保存</button>
       </div>
      
   </div>

   <PopupWindow v-model:isShow="isView">
      <div v-if="selectedImg!=null" class="d-flex justify-content-center">
          <img :src="selectedImg" style="max-width: 8rem;">
      </div>
  </PopupWindow>

  <PopupWindow v-model:isShow="showPopup" >
              <TemplateChoosen @set_template="addTemplate"></TemplateChoosen>
  </PopupWindow>

 </template>
 
 <script>
 
 import GridLoader from 'vue-spinner/src/GridLoader.vue'
 import axios from 'axios';
 
 import PopupWindow from "@/components/PopupWindow.vue";
 import TemplateChoosen from './TemplateChoosen.vue';

 export default {
   data(){
     return {
       isLoading:false,
      
       isView:false,
       selectedImg:null,
       error:'',
       replace_index:-1,
      
       spinnerColor:"#262626",
       showPopup:false,
      
       folderUploadProgress:0,
       img_title:null,
       img_content:null,
       title:null,
       content:null,
       tags:null,
       publish_time:null,
       imgs:[],
       errors:[],
       note_type:'img',
       video_url:null,
      
       currentDate: new Date().toISOString().split('T')[0],
    
       currentTime: new Date().toTimeString().split(' ')[0].slice(0, 5)
       
       
     }
     
   },
  
   computed: {


 },
 
   components: {
    GridLoader,
    PopupWindow,
    TemplateChoosen
   },
    setup(){
      var token=localStorage.getItem('sessionToken')
      axios.defaults.headers.common['X-Parse-Session-Token'] = token
      
   },
 
 
   mounted(){
    console.log(new Date())
    var token=localStorage.getItem('sessionToken')
     
        if(token==undefined || token==null ||token=='')
      {
        this.$router.push('/')
        return
      }
      axios.defaults.headers.common['X-Parse-Session-Token'] = token
      this.account_id=this.$route.params.id
    

   },
   methods:{
   

    async new_note(){
      try{
          
          this.isLoading=true

         
          
          const response = await axios.post(this.domain+'xhs/new_note',{
          'imgs':this.imgs,
          'title':this.title,
          'content':this.content,
          'account_id':this.account_id,
          'video':this.video_url,
        
          'tags':this.tags,
          'publish_date':this.currentDate,
         'publish_time':this.currentTime});

          var data=response.data
          console.log(data)
          console.log(data['status']=='Suc')
          if(data['status']=='Suc')
          {
              this.$router.go(-1)
              
          }
      }
      catch(error)
      {
          console.error(error)
      }
      finally
      {
          this.isLoading=false
      }


    },
    selectFile(index){
      console.log(index)
      this.note_type='img'
      this.replace_index=index;
      this.$refs.fileInput.click()
    },
    selectFiles(){
      this.note_type='img'
        this.$refs.filesInput.click()
      
            
        },

    selectVideo(){
      this.note_type='video'
      this.$refs.videoInput.click()
    },

    uploadFolder(type,is_video){
            this.isLoading=true
            this.errors=[]
            try{
                var files =null
                if (type==0)
                {
                    files =  this.$refs.fileInput.files;
                }
                else if(type==1)
                {
                    files =  this.$refs.filesInput.files;
                }
                else if(type==2)
                {
                  files=this.$refs.videoInput.files;
                }
                
                console.log(files)
                const data = new FormData();
                for (let i = 0; i < files.length; i++) {
                   
                const file = files[i];
                console.log(file.type)
                if(is_video)
                {
                    if (!file.type.startsWith('video/')) {
                    console.log(file.name)
                        this.errors.push(file.name+'不是视频类型，无法上传')
                        console.log(this.errors)
                        continue;  //如果文件不是图片，就跳过这个文件
                    }
                }
                else
                {
                   if (!file.type.startsWith('image/')) {
                    console.log(file.name)
                        this.errors.push(file.name+'不是图片类型，无法上传')
                        console.log(this.errors)
                        continue;  //如果文件不是图片，就跳过这个文件
                    }
                }
               

                    
                data.append('file', file);
            }

          
            this.$refs.filesInput.value = ''

            const config = {
                onUploadProgress: progressEvent => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                );
                this.folderUploadProgress = percentCompleted;
                },
            };

        console.log(data)

        this.progressing=true;
            axios
            .post(this.domain+"xhs/upload_note_imgs", data, config)
            .then(response => {
                console.log(response)
                let dataResponse=response.data
                if (dataResponse['status']=='Suc')
                {
                     var urls=dataResponse['photoes']
                    console.log(urls)
                    if(urls.length==0)
                    {
                      this.errors='文件上传失败'
                      return

                    }
                    if(this.replace_index>=0)
                    {
                      if(this.note_type=='img')
                    {
                        this.imgs[this.replace_index]=urls[0]
                        this.replace_index=-1;
                    }
                     
                    }
                    else
                    {
                      if(this.note_type=='img')
                      {
                        this.imgs.push(...urls)
                      }
                      else{
                        this.video_url=urls[0]
                      }
                      
                    }
                    
                    this.folderUploadProgress=101
                     
                    
                }
            // 处理响应
            })
            .catch(error => {
                console.log(error)
                this.errors=error;
            // 处理错误
            });
            }
            catch(error){
                console.error(error)
                this.errors=error;
            }
            finally{
                console.log('finished')
                this.isLoading=false
            }
       
    },
    
    back(){
      this.$router.go(-1)
    },
    view(img){
      this.isView=true;
      this.selectedImg=img;
    },
    async deleteItem(index){
      console.log(this.note.imgs.length)
  
      if (window.confirm("确定要删除吗?")) {
          this.isLoading=true
          this.note.imgs.splice(index,1)

          try{
          
              this.isLoading=true
              const response = await axios.post(this.domain+'xhs/update_note',{'index':index,'note_id':this.note_id});

              var data=response.data
              if(data.status!='Suc')
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally
          {
              this.isLoading=false
          }
                  
      }
      
    }
     
   }
    
   
 };
 </script>
<style scoped>
.green_border{
  border:0.0375 solid green;
}
.account_icon{
width: 0.35rem;
height: 0.35rem;
border-radius: 0.35rem;
}
.img{
  width:3.5rem;
  border-radius: 0.125rem 0 0 0.125rem;
}
.card{
background: white;
border-radius: 0.125rem;
width:30%;
height:2rem;
}
.cardRight{
height:2rem;
}
.cardText{
color: #262626;
font-family: "Alibaba PuHuiTi";
font-size: 0.175rem;
font-style: normal;
font-weight: 500;
text-align: left;
}
.icon{
width:0.175rem;
height:0.175rem;
}

.pageBox{
width: 0.3125rem;
height:0.3125rem;
border-radius: 0.125rem;
cursor:pointer;
display: flex;
justify-content: center;
align-items: center;

font-family: "Alibaba PuHuiTi";
font-size: 0.175rem;
font-style: normal;
font-weight: 500;
}
.normalPage{
background: white;
color: #262626;
}

.selectedPageBox
{
background: #3b64ff;
color:white
}

</style>
 